import { combineReducers } from 'redux';
import channels from './channels';
import fetching from './fetching';
import last from './last';
import page from './page';
import size from './size';
import totalElements from './totalElements';
import totalPages from './totalPages';

export default combineReducers({
  channels,
  fetching,
  last,
  page,
  size,
  totalElements,
  totalPages,
});
